/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Welcome_TitleInputs */

const en_onboarding_welcome_title = /** @type {(inputs: Onboarding_Welcome_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welcome to Alchema`)
};

const de_onboarding_welcome_title = /** @type {(inputs: Onboarding_Welcome_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Willkommen bei Alchema`)
};

const fr_onboarding_welcome_title = /** @type {(inputs: Onboarding_Welcome_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bienvenue sur Alchema`)
};

const es_onboarding_welcome_title = /** @type {(inputs: Onboarding_Welcome_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bienvenido a Alchema`)
};

const it_onboarding_welcome_title = /** @type {(inputs: Onboarding_Welcome_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benvenuto in Alchema`)
};

const nl_onboarding_welcome_title = /** @type {(inputs: Onboarding_Welcome_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welkom bij Alchema`)
};

const pl_onboarding_welcome_title = /** @type {(inputs: Onboarding_Welcome_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Witamy w Alchema`)
};

const fi_onboarding_welcome_title = /** @type {(inputs: Onboarding_Welcome_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tervetuloa Alchemaan`)
};

const da_onboarding_welcome_title = /** @type {(inputs: Onboarding_Welcome_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Velkommen til Alchema`)
};

const sv_onboarding_welcome_title = /** @type {(inputs: Onboarding_Welcome_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Välkommen till Alchema`)
};

/**
* | output |
* | --- |
* | "Welcome to Alchema" |
*
* @param {Onboarding_Welcome_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const onboarding_welcome_title = /** @type {((inputs?: Onboarding_Welcome_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Welcome_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_onboarding_welcome_title(inputs)
	if (locale === "fr") return fr_onboarding_welcome_title(inputs)
	if (locale === "es") return es_onboarding_welcome_title(inputs)
	if (locale === "it") return it_onboarding_welcome_title(inputs)
	if (locale === "nl") return nl_onboarding_welcome_title(inputs)
	if (locale === "pl") return pl_onboarding_welcome_title(inputs)
	if (locale === "fi") return fi_onboarding_welcome_title(inputs)
	if (locale === "da") return da_onboarding_welcome_title(inputs)
	if (locale === "sv") return sv_onboarding_welcome_title(inputs)
	return en_onboarding_welcome_title(inputs)
});